const GUEST_QUEUE_KEY = 'theoric_guest_event_queue';
const PENDING_RITUAL_KEY = 'theoric_pending_ritual_handles';

function saveGuestArray(key, arr) {
  localStorage.setItem(key, JSON.stringify(arr));
}
function loadGuestArray(key) {
  try { return JSON.parse(localStorage.getItem(key) || '[]'); }
  catch (_) { return []; }
}

function flushGuestData(customerId) {
  if (!customerId) return;

  const handles = loadGuestArray(PENDING_RITUAL_KEY);
  if (handles.length) {
    atualizarRitualDoCliente(customerId, handles);
    localStorage.removeItem(PENDING_RITUAL_KEY);
  }

  const guestEvents = loadGuestArray(GUEST_QUEUE_KEY);
  if (guestEvents.length) {
    guestEvents.forEach(ev => ev.customer_id = customerId);
    guestEvents.forEach(addToEventQueue);
    sendBatchEvents();
    localStorage.removeItem(GUEST_QUEUE_KEY);
  }

  localStorage.removeItem('ritualPending');
}

(function () {
  const tryFlush = () => {
    const cid = document.body.dataset.customerId;
    if (cid) { flushGuestData(cid); return true; }
    return false;
  };

  document.addEventListener('DOMContentLoaded', () => {
    if (tryFlush()) return;

    // IMPORTANTE: arrow functions não têm `this` próprio — salvar referência explícita para poder desconectar.
    const _customerObserver = new MutationObserver(() => {
      if (tryFlush()) _customerObserver.disconnect();
    });
    _customerObserver.observe(document.body, { attributes: true, attributeFilter: ['data-customer-id'] });
  });
})();

const EVENT_QUEUE_KEY = 'theoric_worker_event_queue';
let batchSendTimer = null;

function stripHTML(html = '') {
  return html.replaceAll(/<[^<>]+>/g, '').trim();
}

function getResultTextsFromQuizCache() {
  try {
    const raw = sessionStorage.getItem('theoric_quiz_state');
    if (!raw) return null;
    const state = JSON.parse(raw);

    if (!state.isComplete) return null;

    const heading = document.getElementById('quizResultHeading');
    const desc = document.getElementById('quizResultDescription');

    if (heading || desc) {
      return {
        heading: heading ? heading.textContent.trim() : '',
        description: desc ? desc.textContent.trim() : ''
      };
    }

    return null;
  } catch (_err) {
    return null;
  }
}

function getEventQueueFromStorage() {
  try {
    const queueJSON = localStorage.getItem(EVENT_QUEUE_KEY);
    return queueJSON ? JSON.parse(queueJSON) : [];
  } catch (e) {
    return [];
  }
}

function saveEventQueueToStorage(queue) {
  localStorage.setItem(EVENT_QUEUE_KEY, JSON.stringify(queue));
}

function addToEventQueue(eventData) {
  const queue = getEventQueueFromStorage();
  queue.push(eventData);
  saveEventQueueToStorage(queue);
}

async function sendBatchEvents() {
  const queue = getEventQueueFromStorage();
  if (queue.length === 0) return;

  const workerUrl = 'https://theoric-n8n-webhook.ns2f8o.easypanel.host/webhook/events';

  try {
    const res = await fetch(workerUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(queue),
      keepalive: true
    });
    if (res.ok) {
      saveEventQueueToStorage([]);
    } else {
      console.error(`Falha ao enviar lote. Status: ${res.status}`);
    }
  } catch (err) {
    console.error("Erro de rede ao enviar lote:", err);
  }

  if (batchSendTimer) {
    clearTimeout(batchSendTimer);
    batchSendTimer = null;
  }
}

let currentRecommendationId = null;
let isQuizCompleted = false;

function iniciarQuiz() {
  isQuizCompleted = false;
  const validCrypto = window.crypto || window.msCrypto;
  let randomPart;
  if (validCrypto && validCrypto.getRandomValues) {
    const array = new Uint32Array(2);
    validCrypto.getRandomValues(array);
    randomPart = (array[0].toString(36) + array[1].toString(36)).substr(0, 9);
  } else {
    randomPart = Math.random().toString(36).substr(2, 9);
  }
  currentRecommendationId = 'rec_' + new Date().getTime() + '_' + randomPart;

  if (batchSendTimer) clearTimeout(batchSendTimer);
  batchSendTimer = setTimeout(() => {
    handleQuizAbandonment();
    sendBatchEvents();
  }, 600000);
}

function handleQuizAbandonment() {
  if (!currentRecommendationId || isQuizCompleted) return;

  try {
    const quizStateRaw = sessionStorage.getItem('theoric_quiz_state');
    const customerId = document.body.dataset.customerId;

    const commonEventData = {
      recommendation_id: currentRecommendationId,
      customer_id: customerId,
      session_id: window.ShopifyAnalytics?.lib?.user?.().traits()?.uniqToken,
      location_path: window.location.pathname,
      algorithm_used: 'quiz-ritual'
    };

    if (!quizStateRaw) {
      addToEventQueue({
        ...commonEventData, type: 'quiz_abandoned_start',
        metadata: { message: 'Usuario fechou antes de qualquer interacao.' }
      });
      return;
    }

    const state = JSON.parse(quizStateRaw);

    if (state.isComplete && state.resultHandles && state.resultHandles.length > 0) {
      addToEventQueue({
        ...commonEventData,
        type: 'quiz_abandoned_at_end',
        metadata: {
          message: 'Usuario visualizou resultados mas abandonou antes de salvar o ritual.',
          path: state.path,
          recommendations_shown: state.resultHandles
        }
      });
      return;
    }

    const answered = state.history ? state.history.length : 0;

    if (answered > 0) {
      addToEventQueue({
        ...commonEventData,
        type: 'quiz_abandoned_midway',
        metadata: {
          message: `Usuario abandonou apos responder ${answered} pergunta(s).`,
          path: state.path,
          current_question: state.currentQuestionId,
          answers_count: answered
        }
      });
    } else {
      addToEventQueue({
        ...commonEventData,
        type: 'quiz_abandoned_start',
        metadata: { message: 'Usuario abriu o quiz mas nao respondeu a nenhuma pergunta.' }
      });
    }
  } catch (err) {
    console.error("Erro ao processar abandono do quiz:", err);
  }
}

function fecharQuizSemCompletar() { handleQuizAbandonment(); }

function refazerQuiz() {
  if (currentRecommendationId) {
    addToEventQueue({
      type: 'quiz_retaken',
      recommendation_id: currentRecommendationId,
      customer_id: document.body.dataset.customerId,
      session_id: window.ShopifyAnalytics?.lib?.user?.().traits()?.uniqToken,
      location_path: window.location.pathname,
      algorithm_used: 'quiz-ritual',
      metadata: { message: 'Usuário clicou em refazer o quiz.' }
    });
  }
  iniciarQuiz();
}

async function limparRecomendacoesAntigasDoCarrinho() {
  try {
    const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
    if (!cartResponse.ok) throw new Error('Falha ao buscar o carrinho. Status: ' + cartResponse.status);

    const cart = await cartResponse.json();
    const updates = {};
    let itensParaRemover = 0;

    cart.items.forEach(item => {
      if (item.properties && item.properties['_source'] === 'Recomendação do Quiz') {
        updates[item.key] = 0;
        itensParaRemover++;
      }
    });

    if (itensParaRemover > 0) {
      const updateRes = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
      if (!updateRes.ok) throw new Error('Falha ao remover itens do carrinho. Status: ' + updateRes.status);
    }

    return true; // Limpeza bem-sucedida
  } catch (error) {
    console.error("Erro ao limpar recomendações antigas do carrinho:", error);
    return false; // Sinaliza falha para evitar adição de duplicatas
  }
}

function salvarItemParaDepois(productGid, variantGid = null) {
  const customerId = document.body.dataset.customerId || null;
  const isGuest = !customerId;

  const base = {
    type: 'item_saved',
    customer_id: customerId,
    session_id: window.ShopifyAnalytics?.lib?.user?.().traits()?.uniqToken,
    location_path: window.location.pathname,
    algorithm_used: 'favorite_button',
    metadata: { product_gid: productGid }
  };
  if (variantGid) base.metadata.variant_gid = variantGid;

  if (isGuest) {
    const list = loadGuestArray(GUEST_QUEUE_KEY);
    list.push(base);
    saveGuestArray(GUEST_QUEUE_KEY, list);
  } else {
    addToEventQueue(base);
    sendBatchEvents();
  }
}

// Lock baseado em Promise: garante que apenas UMA execução ocorre por vez.
// Chamadas concorrentes (ex: duplo clique) recebem a mesma Promise de retorno,
// em vez de disparar múltiplas operações no carrinho.
let _ritualLockPromise = null;

async function atualizarRitualDoCliente(customerId, productHandles) {
  if (!customerId || !productHandles?.length) return;

  // Se já está processando, retorna a Promise em andamento (sem duplicar)
  if (_ritualLockPromise) return _ritualLockPromise;

  _ritualLockPromise = (async () => {
    isQuizCompleted = true;

    try {
      // Limpa recomendações antigas ANTES de adicionar novas.
      // Se a limpeza falhar, aborta para evitar itens duplicados no carrinho.
      const cleanOk = await limparRecomendacoesAntigasDoCarrinho();
      if (!cleanOk) {
        console.error('[Theoric] Limpeza do carrinho falhou. Abortando para evitar duplicação de itens.');
        return;
      }

      const productsData = await Promise.all(
        productHandles.map(h => fetch(`/products/${h}.js`).then(r => r.json()))
      );

      const itemsForCartAPI = [];
      const itemsForHistory = [];

      productsData.forEach(product => {
        const variant = product.variants?.[0];
        if (variant) {
          if (variant.available) {
            itemsForCartAPI.push({
              id: variant.id,
              quantity: 1,
              properties: { '_source': 'Recomendação do Quiz' }
            });
          }
          itemsForHistory.push({
            productId: `gid://shopify/Product/${product.id}`,
            variantId: `gid://shopify/ProductVariant/${variant.id}`
          });
        }
      });

      if (!itemsForCartAPI.length) { return; }

      let quizAnswers = null;
      try {
        const quizCacheRaw = localStorage.getItem('quizCache');
        if (quizCacheRaw) {
          const quizCacheData = JSON.parse(quizCacheRaw);
          quizAnswers = quizCacheData?.state?.answers ?? null;
        }
      } catch (e) { console.error("Erro ao ler quizCache:", e); }

      const resultTexts = getResultTextsFromQuizCache();

      const eventMetadata = { products: itemsForHistory };
      if (quizAnswers) eventMetadata.quiz_answers = quizAnswers;
      if (resultTexts) {
        eventMetadata.result_heading = resultTexts.heading;
        eventMetadata.result_description = resultTexts.description;
      }

      addToEventQueue({
        type: 'quiz_result',
        recommendation_id: currentRecommendationId,
        customer_id: customerId,
        session_id: window.ShopifyAnalytics?.lib?.user?.().traits()?.uniqToken,
        location_path: window.location.pathname,
        algorithm_used: 'quiz-ritual',
        metadata: eventMetadata
      });

      sendBatchEvents();

      await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: itemsForCartAPI })
      });

      sessionStorage.setItem('theoric_quiz_toggle', 'on');
      sessionStorage.removeItem('theoric_quiz_items_backup');

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ritual-complete' });
      }

      const cartTheoric = document.querySelector('cart-theoric');
      if (cartTheoric && typeof cartTheoric.open === 'function') {
        setTimeout(() => cartTheoric.open(), 300);
      } else {
        const cartIcon = document.getElementById('cart-icon-bubble');
        if (cartIcon) {
          setTimeout(() => cartIcon.click(), 300);
        }
      }

      const quizPopup = document.getElementById('meuQuizPopup');
      const quizOverlay = document.getElementById('meuQuizOverlay');
      if (quizPopup) {
        quizPopup.style.display = 'none';
        document.body.classList.remove('quiz-popup-open', 'body-no-scroll');
      }
      if (quizOverlay) {
        quizOverlay.style.display = 'none';
      }

    } catch (err) {
      console.error("Erro ao processar ritual:", err);
    }
  })();

  try {
    return await _ritualLockPromise;
  } finally {
    // Lock liberado independente de sucesso ou erro
    _ritualLockPromise = null;
  }
}

const GUEST_FAVORITES_KEY = 'theoric_guest_favorites';

function getGuestFavorites() {
  try {
    const gidsJSON = localStorage.getItem(GUEST_FAVORITES_KEY);
    return gidsJSON ? JSON.parse(gidsJSON) : [];
  } catch (e) { return []; }
}

function saveGuestFavorites(gids) {
  localStorage.setItem(GUEST_FAVORITES_KEY, JSON.stringify(gids));
}

function toggleFavorite(buttonElement, productGid, customerId) {
  return; // FAVORITOS DESABILITADO — remover este return para reativar
  const finalCustomerId = (customerId && customerId !== 'null' && customerId !== '') ? customerId : null;

  if (!productGid || productGid === 'gid://shopify/Product/') {
    console.error("Erro Crítico: O GID do produto não foi construído corretamente.");
    return;
  }

  let isFavorited;

  if (finalCustomerId) {
    let favorites = (document.body.dataset.customerFavorites || '').split(',');
    const itemIndex = favorites.indexOf(productGid.replace('gid://shopify/Product/', ''));
    if (itemIndex > -1) {
      favorites.splice(itemIndex, 1);
      isFavorited = false;
    } else {
      favorites.push(productGid.replace('gid://shopify/Product/', ''));
      isFavorited = true;
    }
    document.body.dataset.customerFavorites = favorites.join(',');

    updateCustomerFavoritesMetafield(finalCustomerId, favorites.map(id => `gid://shopify/Product/${id}`));

  } else {
    const guestFavorites = getGuestFavorites();
    const itemIndex = guestFavorites.indexOf(productGid);

    if (itemIndex > -1) {
      guestFavorites.splice(itemIndex, 1);
      isFavorited = false;
    } else {
      guestFavorites.push(productGid);
      isFavorited = true;
    }
    saveGuestFavorites(guestFavorites);
  }

  if (isFavorited) {
    buttonElement.classList.add('is-favorited');
  } else {
    buttonElement.classList.remove('is-favorited');
  }
}

async function updateCustomerFavoritesMetafield(customerId, favoritesGids) {
  if (!customerId) {
    console.error("Não é possível atualizar metafield de favoritos: ID do cliente ausente.");
    return;
  }

  const workerEndpoint = 'https://theoric-n8n-webhook.ns2f8o.easypanel.host/webhook/update-customer-metafield';

  const payload = {
    customerId: customerId,
    metafieldNamespace: 'custom',
    metafieldKey: 'favoritos',
    value: favoritesGids
  };

  try {
    const response = await fetch(workerEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      console.error(`Falha ao atualizar metafield de favoritos: Status ${response.status}`, await response.text());
    }
  } catch (error) {
    console.error("Erro de rede ao atualizar metafield de favoritos:", error);
  }
}

function initializeFavoriteButtons() {
  return; // FAVORITOS DESABILITADO — remover este return para reativar
  const loggedInFavorites = (document.body.dataset.customerFavorites || '').split(',').map(id => `gid://shopify/Product/${id}`);
  const guestFavorites = getGuestFavorites();

  const buttons = document.querySelectorAll('.button-favorito');
  if (buttons.length === 0) return;

  buttons.forEach(button => {
    const productGid = button.dataset.productGid;
    const isFavorited = loggedInFavorites.includes(productGid) || guestFavorites.includes(productGid);

    if (isFavorited) {
      button.classList.add('is-favorited');
    } else {
      button.classList.remove('is-favorited');
    }
  });
}

const runOnce = (fn) => {
  let hasRun = false;
  return (...args) => {
    if (!hasRun) {
      hasRun = true;
      fn(...args);
    }
  };
};

const initFavButtonsOnce = runOnce(initializeFavoriteButtons);

document.addEventListener('DOMContentLoaded', () => {
  initFavButtonsOnce();
});

document.addEventListener('shopify:section:load', () => {
  initializeFavoriteButtons();
});

window.addEventListener('load', () => {
  setTimeout(() => initFavButtonsOnce(), 100);
});

document.addEventListener('DOMContentLoaded', function () {
  const quizPopup = document.getElementById('meuQuizPopup');
  const quizOverlay = document.getElementById('meuQuizOverlay');

  document.body.addEventListener('click', function (event) {
    const target = event.target;

    const isCloseButtonClick = target.closest('.js-close-quiz-popup');
    const isOverlayClick = target === quizOverlay;
    const isPopupContainerClick = target === quizPopup;

    if (isCloseButtonClick || isOverlayClick || isPopupContainerClick) {
      fecharQuizSemCompletar();
      return;
    }

    if (target.closest('#retake-quiz-btn')) {
      refazerQuiz();
    }
  });
});

window.addEventListener('beforeunload', () => {
  if (localStorage.getItem('ritualPending') === '1') return;

  handleQuizAbandonment();
  sendBatchEvents();
});
